import { WhatsappTemplateParameter, WhatsappTemplateSchema } from "./WhatsappContext";

/**
 * Build a readable preview from the raw template body and parameter definitions.
 * Always uses `body` (never pre-built `message`) so edits to parameter values update live.
 */

export const buildTemplatePreview = (
    template: WhatsappTemplateSchema,
    paramOverrides: Record<string, string> = {},
): string => {
    let body = template.body || template.message_template || template.full_message || template.message || "";
    if (!body) {
        return "No message body configured for this template.";
    }

    const params = template.parameters || [];
    params.forEach((parameter: WhatsappTemplateParameter, index: number) => {
        const key = parameter.key;
        const label = parameter.label || key || `Parameter ${index + 1}`;
        const override = key ? paramOverrides[key] : undefined;
        const value =
            override !== undefined && override.trim() !== ""
                ? override
                : parameter.default || `<${label}>`;

        if (key) {
            body = body.split(`{${key}}`).join(value);
        }
        body = body.split(`{{${index + 1}}}`).join(value);
    });

    return body;
};
